var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 92,
    viewBox: "0 0 82 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#jd5e4l4tna)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 42.9 11.5 27.15 37 11.4l25.5 15.75L37 42.9z",
    fill: "url(#msht70b4yb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 72.6V42.9l25.5-15.75v29.7L37 72.6z",
    fill: "url(#gwdy5um2ec)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 72.6 11.5 56.85v-29.7L37 42.9v29.7z",
    fill: "url(#6hlmg91fad)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "msht70b4yb",
    x1: 11.5,
    y1: 11.4,
    x2: 72.729,
    y2: 29.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E8AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gwdy5um2ec",
    x1: 37,
    y1: 27.15,
    x2: 69.985,
    y2: 30.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E8AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6hlmg91fad",
    x1: 11.5,
    y1: 27.15,
    x2: 44.485,
    y2: 30.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E8AB0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "jd5e4l4tna",
    x: -10,
    y: -5,
    width: 102,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258824 0 0 0 0 0.368627 0 0 0 0 0.658824 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6265_89457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6265_89457",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeImg);
export default __webpack_public_path__ + "static/media/cube_img.ad0798d67e1f9386e9be14833b56edf3.svg";
export { ForwardRef as ReactComponent };